import api from '../token';

export const AddUsuario = async (dados) => {
  try {
    const response = await api.post('/addUser',dados);
    return response.data;
  } catch (error) {
    
    return [];
  }
};

